import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConnectCoreModule } from '@aveva/connect-web-core';
import { TrainingRoutingModule } from './training-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MomentLocalizedDateModule } from '../shared/moment-localized-date/moment-localized-date.module';

import { CdkTableModule } from '@angular/cdk/table';

import { TrainingComponent } from './training.component';
import { HomeComponent } from './home/home.component';
import { TrainingsListComponent } from './training-list/training-list.component';
import { TrainingsComponent } from './trainings/trainings.component';
import { AddClassComponent } from './classes/add-class/add-class.component';
import { AddStudentComponent } from './students/add-student/add-student.component';
import { AccountSelectorInputAsyncComponent } from './accounts/account-selector-input-async/account-selector-input-async.component';

import { AccountResolverService } from '../services/account-resolver.service';
import { ImportStudentsComponent } from './import/import-students/import-students.component';
import { ImportErrorsComponent } from './import/import-errors/import-errors.component';

import { AssignCdsAccesstokenComponent } from './assignments/assign-cds-accesstoken/assign-cds-accesstoken.component';
import { AssignmentsListComponent } from './assignments/assignments-list/assignments-list.component';
import { AddAccountComponent } from './accounts/add-account/add-account.component';
import { AccountsListComponent } from './accounts/accounts-list/accounts-list.component';
import { TrainingGuard } from './training.guard';
import { ClipboardModule } from 'ngx-clipboard';
import { ModifyClassComponent } from './classes/modify-class/modify-class.component';
import { DatasetListComponent } from './datasets/dataset-list/dataset-list.component';
import { AddDatasetComponent } from './datasets/add-dataset/add-dataset.component';
import { DatasetSelectorInputAsyncComponent } from './datasets/dataset-selector-input-async/dataset-selector-input-async.component';
import { ConfirmationDialogModule } from '../shared/confirmation-dialog/confirmation-dialog.module';
import { MatSortModule } from '@angular/material/sort';
import { UpdateStudentComponent } from './students/update-student/update-student.component';
import { MembershipListComponent } from './memberships/membership-list/membership-list.component';
import { MembershipAddComponent } from './memberships/membership-add/membership-add.component';
import { AccountsAccessTokenComponent } from './accounts/accounts-access-token/accounts-access-token.component';
import { ConfigurationsListComponent } from './configurations/configurations-list/configurations-list.component';
import { ConfigurationsModifyComponent } from './configurations/configurations-modify/configurations-modify.component';
import { HealthstatsComponent } from './healthstats/healthstats.component';
import { NamespacesListComponent } from './healthstats/namespaces-list/namespaces-list.component';
import { FoldersListComponent } from './healthstats/folders-list/folders-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,    
    TrainingRoutingModule,
    ConnectCoreModule,
    MatButtonModule,
    MatTableModule,
    MatSidenavModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatChipsModule,
    MatTooltipModule,
    MatListModule,
    MatSelectModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSortModule,
    CdkTableModule,
    RouterModule,
    ClipboardModule,
    ConfirmationDialogModule,
    MomentLocalizedDateModule
  ],
  providers: [
    AccountResolverService,
    TrainingGuard,
    DatePipe],
  declarations: [
    HomeComponent,
    TrainingComponent,
    TrainingsComponent,
    TrainingsListComponent,
    AddClassComponent,
    AddStudentComponent,
    AccountSelectorInputAsyncComponent,
    ImportStudentsComponent,
    ImportErrorsComponent,
    AssignCdsAccesstokenComponent,
    AssignmentsListComponent,
    AddAccountComponent,
    AccountsListComponent,
    ModifyClassComponent,
    DatasetListComponent,
    AddDatasetComponent,
    DatasetSelectorInputAsyncComponent,
    UpdateStudentComponent,
    MembershipAddComponent,
    MembershipListComponent,
    AccountsAccessTokenComponent,
    ConfigurationsListComponent,
    ConfigurationsModifyComponent,
    HealthstatsComponent,
    NamespacesListComponent,
    FoldersListComponent]
})
export class TrainingModule { }
